var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20%",
    height: "20%",
    viewBox: "0 -0.5 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M2 32h96v51H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3E50",
    d: "M75 85.999h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4c0-1.103.896-2 2-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#23475F",
    d: "M93 89v7.999A2 2 0 0 1 91 99H79a2 2 0 0 1-2-2.001V89c.02-.004 15.994.021 16 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M79.917 99h2V89h-2v10zm4.166 0h1.834V89h-1.834v10zm4-10v10h1.834V89h-1.834z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3E50",
    d: "M21 85.999h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4c0-1.103.896-2 2-2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#23475F",
    d: "M23 89v7.999A2 2 0 0 1 21 99H9a2 2 0 0 1-2-2.001V89c.019-.004 15.995.021 16 0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M9.917 99h2V89h-2v10zm4.166 0h1.833V89h-1.833v10zm4-10v10h1.833V89h-1.833z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEEEF",
    d: "M88 0H12C6.477 0 2 4.478 2 10v22s21.903 7.903 33.854 19.855C47.902 63.902 50 75.999 50 75.999s2.055-12.054 14.081-24.08C76.055 39.946 98 32 98 32V10c0-5.523-4.479-10-10-10z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M58 29c-2.205 0-4-1.794-4-4V14c0-2.206 1.795-4 4-4h26c2.206 0 4 1.794 4 4v11c0 2.206-1.794 4-4 4H58z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEEEF",
    d: "M58 29h4l19-19H58c-2.205 0-4 1.794-4 4v11c0 2.205 1.795 4 4 4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M87 11H55v5h17v12h7V16h8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M16 29c-2.206 0-4-1.794-4-4V14c0-2.206 1.794-4 4-4h26c2.205 0 4 1.794 4 4v11c0 2.206-1.795 4-4 4H16z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M45 11H13v5h8v12h7V16h17z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D7DA",
    d: "M2 83h96a2 2 0 0 1 2 1.999v2A2 2 0 0 1 98 89H2a2 2 0 0 1-2-2.001v-2A2 2 0 0 1 2 83z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M79 56c4.971 0 9 4.029 9 9s-4.029 9-9 9-9-4.029-9-9 4.029-9 9-9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M79 59c3.312 0 6 2.688 6 6s-2.688 6-6 6-6-2.688-6-6 2.688-6 6-6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M21 56c4.971 0 9 4.029 9 9s-4.029 9-9 9-9-4.029-9-9 4.029-9 9-9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M21 59c3.313 0 6 2.688 6 6s-2.687 6-6 6-6-2.688-6-6 2.687-6 6-6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8CBCB",
    d: "M52.986 37.986C50.824 35.824 47 37 47 37L33.942 50.057c.658.59 1.301 1.188 1.912 1.799 3.479 3.479 6.125 6.961 8.134 10.155L58 48s.713-3.287-.98-4.981c-1.243-1.242-2.702-3.701-4.034-5.033z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M50 36c-4.971 0-9 4.029-9 9s4.029 8.999 9 8.999 9-4.028 9-8.999-4.029-9-9-9zm0 3c1.551 0 2.961.594 4.025 1.561L50 44.586l-4.025-4.026A5.964 5.964 0 0 1 50 39zm0 12a6 6 0 0 1-5.275-8.861L50 47.414l5.275-5.275A6.002 6.002 0 0 1 50 51z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D6D7",
    d: "M72 19l8-8H55.383a3.946 3.946 0 0 0-.383.382V16h17v3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC3C7",
    d: "M84 11c1.654 0 3 1.346 3 3v11c0 1.654-1.346 3-3 3H58c-1.654 0-3-1.346-3-3V14c0-1.654 1.346-3 3-3h26m0-2H58a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h26a5 5 0 0 0 5-5V14a5 5 0 0 0-5-5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEEEF",
    d: "M16 29h4l19-19H16c-2.206 0-4 1.794-4 4v11c0 2.205 1.794 4 4 4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D6D7",
    d: "M28 21v-5h5l5-5H13.382a4.05 4.05 0 0 0-.382.382V16h8v12l7-7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDC3C7",
    d: "M42 11c1.654 0 3 1.346 3 3v11c0 1.654-1.346 3-3 3H16c-1.654 0-3-1.346-3-3V14c0-1.654 1.346-3 3-3h26m0-2H16a5 5 0 0 0-5 5v11a5 5 0 0 0 5 5h26a5 5 0 0 0 5-5V14a5 5 0 0 0-5-5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.d9c9f324a9a42905848a9b07f61cf919.svg";
export { ForwardRef as ReactComponent };